// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X6CX","label":"styles_label__wklSe"};